<p-table
  [value]="historik()"
  stripedRows
  [loading]="data.isLoading()"
  [scrollable]="true"
  scrollHeight="flex"
  class="p-datatable-sm lp-table">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 140px">Tidspunkt</th>
      <th>Hændelse</th>
      <th>Kommentar</th>
      <th>Udført af</th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="historik()" pTemplate="body" let-hist>
    <tr>
      <td class="numbers">{{ hist.tidspunkt | date: 'dd-MM-yyyy HH:mm' }}</td>
      <td>
        <pre style="font-family: Montserrat">{{ hist.systemKommentar }}</pre>
      </td>
      <td>{{ hist.kommentar }}</td>
      <td>{{ hist.rettetAf }}</td>
    </tr>
  </ng-template>
</p-table>
